import { useState } from 'react';

const API_ORIGIN = 'https://portal.komak24.com';

export function Install({ slug }: { slug: string }) {
  const [position, setPosition] = useState<'left' | 'right'>('left');
  const [copied, setCopied] = useState(false);

  const snippet =
    `<script src="${API_ORIGIN}/widget.js"\n` +
    `        data-skinbot-inbox="${slug}"\n` +
    `        data-skinbot-position="${position}"\n` +
    `        defer></script>`;

  return (
    <div className="space-y-5">
      <div>
        <h2 className="text-lg font-bold">نصب ویجت روی سایت</h2>
        <p className="text-sm text-ink/50">
          یک تگ اسکریپت، بدون هیچ وابستگی دیگر.
        </p>
      </div>

      <div className="card space-y-4 p-5">
        <div className="flex items-center gap-3">
          <span className="text-sm font-medium">جای حباب:</span>
          {(['left', 'right'] as const).map((p) => (
            <button
              key={p}
              onClick={() => setPosition(p)}
              className={`rounded-lg px-3 py-1.5 text-sm ${
                position === p ? 'bg-brand-row font-medium text-brand' : 'text-ink/50 hover:bg-paper-mute'
              }`}
            >
              {p === 'left' ? 'پایین چپ' : 'پایین راست'}
            </button>
          ))}
        </div>

        <pre className="overflow-x-auto rounded-lg bg-ink-strong p-4 text-xs leading-6 text-paper-mute" dir="ltr">
          {snippet}
        </pre>

        <button
          className="btn-primary"
          onClick={async () => {
            await navigator.clipboard.writeText(snippet);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
          }}
        >
          {copied ? 'کپی شد ✓' : 'کپی کد'}
        </button>
      </div>

      <div className="card space-y-3 p-5 text-sm leading-7">
        <h3 className="font-bold">کجا بگذاریم</h3>
        <p className="text-ink/65">
          در وردپرس: <span className="font-medium">Appearance → Theme File Editor → footer.php</span>{' '}
          درست قبل از <code dir="ltr" className="rounded bg-paper-mute px-1">&lt;/body&gt;</code>،
          یا با هر افزونه‌ای که اجازه‌ی افزودن کد به فوتر می‌دهد.
        </p>

        <h3 className="pt-2 font-bold">شناسایی کاربر عضو (اختیاری)</h3>
        <p className="text-ink/65">
          اگر می‌خواهی در فهرست «آنلاین» به‌جای «بازدیدکننده ۱۰۰۰۰۷» نام واقعی
          کاربران لاگین‌شده را ببینی، این را <b>قبل</b> از تگ بالا اضافه کن:
        </p>
        <pre className="overflow-x-auto rounded-lg bg-ink-strong p-3 text-xs leading-6 text-paper-mute" dir="ltr">
{`<?php if ( is_user_logged_in() ) :
  $u = wp_get_current_user(); ?>
  <script>
    window.skinbotUser = {
      wpUserId:    <?php echo (int) $u->ID; ?>,
      displayName: <?php echo wp_json_encode( $u->display_name ); ?>,
      email:       <?php echo wp_json_encode( $u->user_email ); ?>
    };
  </script>
<?php endif; ?>`}
        </pre>
        <p className="rounded-lg bg-warn-bg px-3 py-2 text-xs text-warn-deep">
          این هویت <b>تأییدشده نیست</b>: هر بازدیدکننده‌ای می‌تواند از کنسول مرورگر
          مقدارش را عوض کند. در پنل هم با برچسب «تأییدنشده» نمایش داده می‌شود.
          برای کارهای حساس مثل نمایش سفارش، باید منتظر افزونه وردپرس با توکن
          امضاشده بمانیم.
        </p>

        <h3 className="pt-2 font-bold">چه چیزی خودکار کار می‌کند</h3>
        <ul className="list-inside list-disc space-y-1 text-ink/65">
          <li>ویجت صفحه‌ی فعلی را می‌فرستد و اگر صفحه‌ی محصول باشد، محصول را می‌شناسد.</li>
          <li>پرسیدن «این ضدآفتاب چطوره؟» در صفحه‌ی محصول، به همان محصول وصل می‌شود.</li>
          <li>استایل داخل Shadow DOM ایزوله است و با قالب فروشگاه تداخل ندارد.</li>
        </ul>
      </div>
    </div>
  );
}
